import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./i18n";
import { ColorModeScript } from "@chakra-ui/react";
import "./styles/global.css";

const container = document.getElementById("root");

const root = createRoot(container!);
// 이전 테마 수정 과정에서 저장된 다크모드 값을 한 번만 라이트모드로 정리합니다.
// 이후 사용자가 선택한 모드는 Chakra가 localStorage에 정상 보존합니다.
const colorModeMigrationKey = "quazar-color-mode-light-migration-v1";
if (!localStorage.getItem(colorModeMigrationKey)) {
  localStorage.setItem("chakra-ui-color-mode", "light");
  localStorage.setItem(colorModeMigrationKey, "done");
}
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode="light" />
    <App />
  </React.StrictMode>
);
